/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import "./style.css";

interface Props {
  className: any;
  text: string;
  frameClassName: any;
  frame: string;
  hasDiv: boolean;
  options: string[];
  dataSelected: string;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  /** option value → 顯示文字（用於 i18n；value 維持原字串送出，僅換顯示） */
  optionLabels?: Record<string, string>;
}

// XXX: deprecated
export const Dropdown = ({
  dataSelected,
  className,
  text = "Type a question",
  hasDiv = true,
  options = [],
  onChange,
  disabled = false,
  optionLabels,
}: Props): JSX.Element => {
  const { t } = useTranslation("common");
  return (
    <div className={`dropdown ${className}`}>
      <div className="type-a-question-2">{text}</div>
      <div className="frame-2">
        <select className="div-wrapper"
          {...{ disabled }}
          value={dataSelected}
          onChange={onChange}
          required
        >
          {!dataSelected && <option value="">{t("form.selectPlaceholder")}</option>}
          {options.map((option) => (
            <option key={option} value={option}>
              {optionLabels?.[option] ?? option}
            </option>
          ))}
        </select>
      </div>
      {hasDiv && <div className="text-wrapper-4">Type an error message</div>}
    </div>
  );
};

Dropdown.propTypes = {
  text: PropTypes.string,
  frame: PropTypes.string,
  hasDiv: PropTypes.bool,
};
